import React,{useEffect} from 'react';
import {connect} from 'react-redux';
import Navbar from './Navbar';
import {clearSecrets} from '../store/teachActions';

const TeachAccountAdded = ({secrets,clearSecrets,history}) => {
  useEffect(()=>{
    if(!secrets || secrets.length<1){
      history.push('/teachadminhome');
    }
    return (()=> {
      clearSecrets();
    });
  });

  return (
    <>
      <Navbar title={'Teach Account Management'}/>
      <div style={{'margin':'25px 0px 25px 0px'}}></div>
      <div className='container col s8'>
        <ul className='collection'>
          { secrets!=null && secrets.length>0
            ? secrets.map((v,i)=>{
                return (
                  <div key={20+i} className='row collection-item green lighten-5'>
                    <li>{v.uid}:{v.uidNumber}:{v.gidNumber}:{v.homeDirectory}:{v.password}</li>
                  </div>
                )
              })
            : <div className='progress valign-wrapper'> <div className='indeterminate'></div></div>
          }
        </ul>
        <div>
          <button className="btn waves-effect waves-light" type="submit" name="action"
            onClick={()=>history.push('/teachadminhome')}>Back
          </button>
        </div>
      </div>
    </>
  );
};

const mapStoreToProps = state => ({
  secrets: state.teach.secrets
});

export default connect(mapStoreToProps,{clearSecrets})(TeachAccountAdded);
